module.exports = __webpack_public_path__ + "static/media/skwiz-character.cd51594b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/skwiz-character.gif
// module id = ./src/assets/Home/skwiz-character.gif
// module chunks = 0